export const optionsSearch = (input, option) =>
  (option.props.children &&
    typeof option.props.children.toLowerCase === "function" &&
    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0) ||
  (option.props.value &&
    typeof option.props.value.toLowerCase === "function" &&
    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0);
